import { render, staticRenderFns } from "./detail_basic.vue?vue&type=template&id=57b5b252"
import script from "./detail_basic.vue?vue&type=script&lang=js"
export * from "./detail_basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57b5b252')) {
      api.createRecord('57b5b252', component.options)
    } else {
      api.reload('57b5b252', component.options)
    }
    module.hot.accept("./detail_basic.vue?vue&type=template&id=57b5b252", function () {
      api.rerender('57b5b252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_related_information_report/visitDetail/components/detail_basic.vue"
export default component.exports